<template>
  <div class="questionnaire">
    <div class="questionnaireBox">
      <el-row>
        <el-col :span="22">{{titleShow}}</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="formBox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="问卷名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入问卷名称"
              maxlength="20"
            ></el-input>
          </el-form-item>

          <el-form-item label="问卷分类" prop="surveyClassID">
            <el-select
              v-model="ruleForm.surveyClassID"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="适用范围" prop="scope">
            <el-radio-group v-model="ruleForm.scope">
              <el-radio :label="1" >按门店类型选择</el-radio>
              <el-radio :label="2" disabled>按区域选择</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="适用门店类型" prop="scopes">
            <el-select
              multiple
              class="area"
              v-model="ruleForm.scopes"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in doorTypeList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="options">
            <span class="label">题目</span>
            <div class="optionsContent">
              <div>
                <el-tabs v-model="activeName">
                  <el-tab-pane :label="'陈列 ' + questionData.VMS.length" name="VMS">
                    <SortableList lockAxis="y" v-model="questionDataDetail.VMS">
                      <SortableItem
                        v-for="(question, index) in questionDataDetail.VMS"
                        :index="index"
                        :key="index"
                        :item="question"
                      />
                    </SortableList>
                  </el-tab-pane>
                  <el-tab-pane :label="'运营 ' + questionData.Operation.length" name="Operation">
                    <SortableList lockAxis="y" v-model="questionDataDetail.Operation">
                      <SortableItem
                        v-for="(question, index) in questionDataDetail.Operation"
                        :index="index"
                        :key="index"
                        :item="question"
                      />
                    </SortableList>
                  </el-tab-pane>
                  <el-tab-pane :label="'培训 ' + questionData.Training.length" name="Training">
                    <SortableList lockAxis="y" v-model="questionDataDetail.Training">
                      <SortableItem
                        v-for="(question, index) in questionDataDetail.Training"
                        :index="index"
                        :key="index"
                        :item="question"
                      />
                    </SortableList>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div>
                <el-button
                  plain
                  round
                  size="small"
                  style="color: #67C23A; float: right"
                  @click="searchQuestions()"
                >
                  添 加 / 移 除
                </el-button>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <footer>
        <el-button type="success" @click="save()">
          保 存
        </el-button>
      </footer>
    </div>
    <el-dialog
      title="添加/移除 题目"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div style="width: 100%">
        <el-transfer
          v-model="questionData[activeName]"
          :data="questionsList"
          :button-texts="['移 除', '添 加']"
          filterable
        ></el-transfer>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="submitTransfer()" round >提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";
import { ContainerMixin, ElementMixin } from 'vue-slicksort';

const SortableList = {
  mixins: [ ContainerMixin ],
  template: `
    <ul class="draggable-questionList">
      <slot />
    </ul>
  `,
};

const SortableItem = {
  mixins: [ ElementMixin ],
  props: ['item'],
  data() {
    return {
    }
  },
  template: `
      <li class="draggable-questionItem">
         {{ item.title }}
      </li>
    `,
};

export default {
  name: "QuestionnaireEdit",
  data() {
    return {
      dialogVisible: false,
      titleShow: "新增问卷",  //标题
      id: this.$route.query.id || null,
      scopes: [], //适用门店类型
      activeName: 'VMS',
      ruleForm: { //详情数据
        name: "",  //问卷名称
        scope: 1, //适用范围
        scopes: [], //适用门店类型
        surveyClassID: "", //问卷分类
        questions: [],
      },

      questionData: {
        VMS: [],
        Operation: [],
        Training: []
      },
      questionsListAll: [],
      questionsList: [],
      categoryList: [ //问卷分类
        {
          name: '陈列',
          categoryNo: 1
        },
        {
          name: '运营',
          categoryNo: 2
        },
        {
          name: '培训',
          categoryNo: 3
        },
      ],
      rules: {}, // 验证信息

      questionnaireList: [
        {
        value: '1',
        label: '1.这是题目题目题目题目题目的标题1'
      }, {
        value: '2',
        label: '1.这是题目题目题目题目题目的标题2'
      }, {
        value: '3',
        label: '3.这是题目题目题目题目题目的标题2'
      }, {
        value: '4',
        label: '4.这是题目题目题目题目题目的标题4'
      }, {
        value: '5',
        label: '5.这是题目题目题目题目题目的标题5'
      }],

      questionDataDetail: {
        VMS: [],
        Operation: [],
        Training: []
      }
    }
  },
  components: {
    SortableItem,
    SortableList,
  },
  mounted() {
    this.$store.dispatch("getDoorTypeList"); // 门店类型列表
    this.searchQuestionsAll().then(() => {
      // 如果有查询id,则根据id去获取数据
      if (this.id) {
        this.titleShow = "编辑问卷";
        this.getData()
      }
    });
    this.getCategoryList();
  },
  computed: {
    doorTypeList: ({ $store: { getters } }) => getters.doorTypeList,
  },
  methods: {
    async getCategoryList(){  //问卷类型
      let res = await axios.post(oprReqUrl+"surveyclass/search", {});
      res = res.data
      if (res.code === 200) {
        this.categoryList = res.data.list;
      }
    },
    async searchQuestions(){  //获取题目列表
      let config = {}
      this.dialogVisible = true
      const type = this.getActiveType();
      config = { type }
      let res = await axios.post(oprReqUrl+"question/search", config);
      res = res.data
      if (res.code === 200) {
        let questions = [];
        res.data.list.forEach(function (item){
          let q = {key:item.id,label:item.name};
          questions.push(q)
        });
        this.questionsList = questions;
      }
    },
    async searchQuestionsAll(){  //获取题目列表
      let res = await axios.post(oprReqUrl+"question/search", {});
      res = res.data
      if (res.code === 200) {
        let questions = [];
        res.data.list.forEach(function (item){
          let q = {key:item.id, label:item.name, id:item.id};
          questions.push(q)
        });
        this.questionsListAll = questions;
      }
    },
    async getData() {
      let res = await axios.post(oprReqUrl+"survey/detail", {"id":this.id});
      res = res.data
      if (res.code === 200) {
        const result = res.data;
        this.ruleForm.name = result.name;
        this.ruleForm.scope = result.scope;
        this.ruleForm.surveyClassID = result.surveyClassID;
        this.ruleForm.scopes = result.scopes;
        _.each(result.questions, (question) => {
          if (question.type == 1) {
            this.questionData["VMS"].push(question.id)
          } else if (question.type == 2) {
            this.questionData["Operation"].push(question.id)
          } else if (question.type == 3) {
            this.questionData["Training"].push(question.id)
          }
        })
        this.getQuestionDataDetail()
      }

      console.log('this.questionData', this.questionData)
      console.log('this.questionDataDetail', this.questionDataDetail)
    },
    goBack() {
      this.$router.push({ path: '/opr/questionnaire' });
    },
    async save() {
      const ids = [];
      const questionDataDetail = _.cloneDeep(this.questionDataDetail)
      _.forIn(questionDataDetail, (value, key) => {
        _.each(questionDataDetail[key], (item) => {
          ids.push(item.id)
        })
      });
      this.ruleForm.questions = ids;
      this.ruleForm.id = this.id

      let res = await axios.post(oprReqUrl+"survey/save", this.ruleForm);
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        await this.$router.push({ path: '/opr/questionnaire' });
      }else {
        this.$message.warning(res.message)
      }
    },
    openDialog() {
      // 打开左右移动的弹框
    },
    submitTransfer() {
      console.log('当前穿梭框的选中项为:', this.questionData[this.activeName]);
      this.getQuestionDataDetail(this.activeName);
      this.dialogVisible = false
    },
    getActiveType() {
      let type;
      switch (this.activeName) {
        case "VMS":
          type = 1
          break;
        case "Operation":
          type = 2
          break;
        case "Training":
          type = 3
          break
      }
      return type
    },
    getQuestionDataDetail: function (active) {
      const _this = this;
      if (!active) {
        const result = {
          VMS: [],
          Operation: [],
          Training: []
        };
        _.forIn(_this.questionData, (value, questionKey) => {
          _.each(_this.questionData[questionKey], (questionId) => {
            const matchQuestion = _.find(_this.questionsListAll, (question) => question.id === questionId);
            const { key, label, id } = matchQuestion;
            result[questionKey].push({id, title: `${key}.${label}`})
          });
        });
        this.questionDataDetail = result;
      }
      else if (active) {
        const newResult = _.cloneDeep(this.questionDataDetail);
        newResult[active] = [];
        _.each(this.questionsListAll, (data) => {
          const { key, label, id } = data;
          if (_.indexOf(_this.questionData[active], key) > -1) {
            newResult[active].push({id, title: `${key}.${label}`})
          }
        });
        this.questionDataDetail = newResult;
      }
    }

  }
};
</script>
<style lang="sass">
  .draggable-questionList
    list-style: none
    margin: 0
    margin-bottom: 10px
    padding: 0
    cursor: pointer
  .draggable-questionItem
    list-style: none
    background-color: #FFF
    border-radius: 4px
    border: 1px solid #DCDFE6
    -webkit-box-sizing: border-box
    box-sizing: border-box
    color: #ccc
    display: inline-block
    outline: 0
    padding: 6px 15px
    width: 100%
    font-size: 14px
    margin-bottom: 10px
</style>

<style lang="sass" scoped>
.questionnaire
  min-width: 1050px
  .questionnaireBox
    padding: 20px
    .formBox
      width: 50%
      margin-left: 25%
      margin-top: 20px
    .options
      display: flex
      .optionsContent
        width: 100%
      .label
        text-align: right
        width: 100px
        vertical-align: middle
        float: left
        font-size: 14px
        color: #606266
        line-height: 40px
        height: 40px
        padding: 0 12px 0 0
        -webkit-box-sizing: border-box
        box-sizing: border-box
        flex-shrink: 0
    footer
      padding-top: 30px
      text-align: center
  .dialog-footer
    text-align: center

</style>



// WEBPACK FOOTER //
// src/opr/pages/views/Check/questionnaireEdit.vue